import { z } from 'zod';

export const ApiMetaSchema = z.object({
  requestId: z.string(),
  timestamp: z.string(),
  retryAfterSeconds: z.number().optional(),
});

export const ApiErrorDetailSchema = z.object({
  field: z.string(),
  code: z.string(),
  message: z.string(),
});

export const ApiErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
  details: z.array(ApiErrorDetailSchema).optional(),
});

export function apiEnvelope<T extends z.ZodTypeAny>(dataSchema: T) {
  return z.object({
    success: z.literal(true),
    data: dataSchema,
    meta: ApiMetaSchema,
  });
}

export const ApiErrorEnvelopeSchema = z.object({
  success: z.literal(false),
  error: ApiErrorSchema,
  meta: ApiMetaSchema,
});

export type ApiErrorEnvelope = z.infer<typeof ApiErrorEnvelopeSchema>;
export type ApiErrorBody = z.infer<typeof ApiErrorSchema>;
export type ApiErrorDetail = z.infer<typeof ApiErrorDetailSchema>;
export type ApiMeta = z.infer<typeof ApiMetaSchema>;
